import { Box, Typography } from '@mui/material';

interface InfoCardProps {
  label: string;
  value: string;
  customValue?: React.ReactNode;
}

export function InfoCard({ label, value, customValue }: InfoCardProps) {
  return (
    <Box sx={{ background: '#F6F7FB', borderRadius: 2, p: 2, display: 'flex', flexDirection: 'column', gap: 1 }}>
      <Typography fontSize={13} color="#6B7280">{label}</Typography>
      {customValue || <Typography fontWeight={700} fontSize={17}>{value}</Typography>}
    </Box>
  );
} 